"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupId = void 0;
var GroupId;
(function (GroupId) {
    GroupId["AdditionalData"] = "AdditionalData";
    GroupId["AdsManagerGetStarted"] = "AdsManagerGetStarted";
    GroupId["AdultServices31"] = "AdultServices31";
    GroupId["AdultServices32"] = "AdultServices32";
    GroupId["AdultServices33"] = "AdultServices33";
    GroupId["AdultServices34"] = "AdultServices34";
    GroupId["AdultServices35"] = "AdultServices35";
    GroupId["AdultServices36"] = "AdultServices36";
    GroupId["AdultServices37"] = "AdultServices37";
    GroupId["AdultServices38"] = "AdultServices38";
    GroupId["AdultServices39"] = "AdultServices39";
    GroupId["BankAccount"] = "BankAccount";
    GroupId["BillingBusinessPartner"] = "BillingBusinessPartner";
    GroupId["BusinessInformationGroup"] = "BusinessInformationGroup";
    GroupId["BusinessSize"] = "BusinessSize";
    GroupId["CounterpartyRisk1"] = "CounterpartyRisk1";
    GroupId["CounterpartyRisk10"] = "CounterpartyRisk10";
    GroupId["CounterpartyRisk11"] = "CounterpartyRisk11";
    GroupId["CounterpartyRisk12"] = "CounterpartyRisk12";
    GroupId["CounterpartyRisk13"] = "CounterpartyRisk13";
    GroupId["CounterpartyRisk14"] = "CounterpartyRisk14";
    GroupId["CounterpartyRisk15"] = "CounterpartyRisk15";
    GroupId["CounterpartyRisk16"] = "CounterpartyRisk16";
    GroupId["CounterpartyRisk17"] = "CounterpartyRisk17";
    GroupId["CounterpartyRisk18"] = "CounterpartyRisk18";
    GroupId["CounterpartyRisk19"] = "CounterpartyRisk19";
    GroupId["CounterpartyRisk2"] = "CounterpartyRisk2";
    GroupId["CounterpartyRisk20"] = "CounterpartyRisk20";
    GroupId["CounterpartyRisk21"] = "CounterpartyRisk21";
    GroupId["CounterpartyRisk22"] = "CounterpartyRisk22";
    GroupId["CounterpartyRisk23"] = "CounterpartyRisk23";
    GroupId["CounterpartyRisk24"] = "CounterpartyRisk24";
    GroupId["CounterpartyRisk25"] = "CounterpartyRisk25";
    GroupId["CounterpartyRisk3"] = "CounterpartyRisk3";
    GroupId["CounterpartyRisk4"] = "CounterpartyRisk4";
    GroupId["CounterpartyRisk5"] = "CounterpartyRisk5";
    GroupId["CounterpartyRisk6"] = "CounterpartyRisk6";
    GroupId["CounterpartyRisk7"] = "CounterpartyRisk7";
    GroupId["CounterpartyRisk8"] = "CounterpartyRisk8";
    GroupId["CounterpartyRisk9"] = "CounterpartyRisk9";
    GroupId["Crypto21"] = "Crypto21";
    GroupId["Crypto22"] = "Crypto22";
    GroupId["Crypto23"] = "Crypto23";
    GroupId["Crypto24"] = "Crypto24";
    GroupId["Crypto25"] = "Crypto25";
    GroupId["Crypto26"] = "Crypto26";
    GroupId["Crypto27"] = "Crypto27";
    GroupId["Crypto28"] = "Crypto28";
    GroupId["FinancialServices41"] = "FinancialServices41";
    GroupId["FinancialServices42"] = "FinancialServices42";
    GroupId["FinancialServices43"] = "FinancialServices43";
    GroupId["FinancialServices44"] = "FinancialServices44";
    GroupId["FinancialServices45"] = "FinancialServices45";
    GroupId["FinancialServices46"] = "FinancialServices46";
    GroupId["FinancialServices47"] = "FinancialServices47";
    GroupId["FinancialServices48"] = "FinancialServices48";
    GroupId["Gambling11"] = "Gambling11";
    GroupId["Gambling110"] = "Gambling110";
    GroupId["Gambling12"] = "Gambling12";
    GroupId["Gambling13"] = "Gambling13";
    GroupId["Gambling14"] = "Gambling14";
    GroupId["Gambling15"] = "Gambling15";
    GroupId["Gambling16"] = "Gambling16";
    GroupId["Gambling17"] = "Gambling17";
    GroupId["Gambling18"] = "Gambling18";
    GroupId["Gambling19"] = "Gambling19";
    GroupId["GroupConfirmation"] = "GroupConfirmation";
    GroupId["IllegalItemsProhibitedSegmentsControls1"] = "IllegalItemsProhibitedSegmentsControls1";
    GroupId["IllegalItemsProhibitedSegmentsControls2"] = "IllegalItemsProhibitedSegmentsControls2";
    GroupId["IllegalItemsProhibitedSegmentsControls3"] = "IllegalItemsProhibitedSegmentsControls3";
    GroupId["InStoreGetStarted"] = "InStoreGetStarted";
    GroupId["InStoreLegalForm"] = "InStoreLegalForm";
    GroupId["InStoreRegisteredAddress"] = "InStoreRegisteredAddress";
    GroupId["InStoreRegistration"] = "InStoreRegistration";
    GroupId["InStoreStakeholder"] = "InStoreStakeholder";
    GroupId["InStoreStores"] = "InStoreStores";
    GroupId["InStoreVat"] = "InStoreVat";
    GroupId["KeyPerformanceIndicator1"] = "KeyPerformanceIndicator1";
    GroupId["KeyPerformanceIndicator3"] = "KeyPerformanceIndicator3";
    GroupId["KycBearerShares"] = "KycBearerShares";
    GroupId["KycGetStarted"] = "KycGetStarted";
    GroupId["KycNomineeShareholders"] = "KycNomineeShareholders";
    GroupId["KycPersons"] = "KycPersons";
    GroupId["Licensing"] = "Licensing";
    GroupId["MandatoryConfirmation1"] = "MandatoryConfirmation1";
    GroupId["MandatoryConfirmation2"] = "MandatoryConfirmation2";
    GroupId["Monitoring41"] = "Monitoring41";
    GroupId["Monitoring42"] = "Monitoring42";
    GroupId["Monitoring43"] = "Monitoring43";
    GroupId["Monitoring44"] = "Monitoring44";
    GroupId["NestedModel1"] = "NestedModel1";
    GroupId["NestedModel10"] = "NestedModel10";
    GroupId["NestedModel11"] = "NestedModel11";
    GroupId["NestedModel12"] = "NestedModel12";
    GroupId["NestedModel13"] = "NestedModel13";
    GroupId["NestedModel2"] = "NestedModel2";
    GroupId["NestedModel3"] = "NestedModel3";
    GroupId["NestedModel4"] = "NestedModel4";
    GroupId["NestedModel5"] = "NestedModel5";
    GroupId["NestedModel6"] = "NestedModel6";
    GroupId["NestedModel7"] = "NestedModel7";
    GroupId["NestedModel8"] = "NestedModel8";
    GroupId["NestedModel9"] = "NestedModel9";
    GroupId["OnboardingAndCustomerDueDiligence11"] = "OnboardingAndCustomerDueDiligence11";
    GroupId["OnboardingAndCustomerDueDiligence12"] = "OnboardingAndCustomerDueDiligence12";
    GroupId["OnboardingAndCustomerDueDiligence13"] = "OnboardingAndCustomerDueDiligence13";
    GroupId["OnboardingAndCustomerDueDiligence14"] = "OnboardingAndCustomerDueDiligence14";
    GroupId["OnboardingAndCustomerDueDiligence15"] = "OnboardingAndCustomerDueDiligence15";
    GroupId["OnboardingAndCustomerDueDiligence16"] = "OnboardingAndCustomerDueDiligence16";
    GroupId["OnboardingAndCustomerDueDiligence17"] = "OnboardingAndCustomerDueDiligence17";
    GroupId["OnboardingAndCustomerDueDiligence18"] = "OnboardingAndCustomerDueDiligence18";
    GroupId["OnboardingAndCustomerDueDiligence19"] = "OnboardingAndCustomerDueDiligence19";
    GroupId["OnboardingAndCustomerDueDiligence20"] = "OnboardingAndCustomerDueDiligence20";
    GroupId["OnboardingAndCustomerDueDiligence21"] = "OnboardingAndCustomerDueDiligence21";
    GroupId["OnboardingAndCustomerDueDiligence22"] = "OnboardingAndCustomerDueDiligence22";
    GroupId["OnboardingAndCustomerDueDiligence23"] = "OnboardingAndCustomerDueDiligence23";
    GroupId["PartnerBank"] = "PartnerBank";
    GroupId["PartnerBankChangeNotification"] = "PartnerBankChangeNotification";
    GroupId["PartnerBankCollaborationDetails"] = "PartnerBankCollaborationDetails";
    GroupId["PartnerBankContractEntity"] = "PartnerBankContractEntity";
    GroupId["PartnerBankFinancialLicense"] = "PartnerBankFinancialLicense";
    GroupId["PartnerBankFinancialLicenseObtain"] = "PartnerBankFinancialLicenseObtain";
    GroupId["PartnerBankPayouts"] = "PartnerBankPayouts";
    GroupId["PartnerBankSanctionsCompliance"] = "PartnerBankSanctionsCompliance";
    GroupId["PartnerBankSwitch"] = "PartnerBankSwitch";
    GroupId["PoliticallyExposedPersonsAdverseMediaScreening21"] = "PoliticallyExposedPersonsAdverseMediaScreening21";
    GroupId["PoliticallyExposedPersonsAdverseMediaScreening22"] = "PoliticallyExposedPersonsAdverseMediaScreening22";
    GroupId["PoliticallyExposedPersonsAdverseMediaScreening23"] = "PoliticallyExposedPersonsAdverseMediaScreening23";
    GroupId["PoliticallyExposedPersonsAdverseMediaScreening24"] = "PoliticallyExposedPersonsAdverseMediaScreening24";
    GroupId["PoliticallyExposedPersonsAdverseMediaScreening25"] = "PoliticallyExposedPersonsAdverseMediaScreening25";
    GroupId["ProductChannel"] = "ProductChannel";
    GroupId["ProgramDetailsAndGovernance1"] = "ProgramDetailsAndGovernance1";
    GroupId["ProgramDetailsAndGovernance2"] = "ProgramDetailsAndGovernance2";
    GroupId["ProgramDetailsAndGovernance3"] = "ProgramDetailsAndGovernance3";
    GroupId["ProgramDetailsAndGovernance4"] = "ProgramDetailsAndGovernance4";
    GroupId["ProgramDetailsAndGovernance5"] = "ProgramDetailsAndGovernance5";
    GroupId["ProgramDetailsAndGovernance6"] = "ProgramDetailsAndGovernance6";
    GroupId["ProgramDetailsAndGovernance7"] = "ProgramDetailsAndGovernance7";
    GroupId["ProgramDetailsAndGovernance8"] = "ProgramDetailsAndGovernance8";
    GroupId["SanctionsControls310"] = "SanctionsControls310";
    GroupId["SanctionsControls3111"] = "SanctionsControls3111";
    GroupId["SanctionsControls3112"] = "SanctionsControls3112";
    GroupId["SanctionsControls311"] = "SanctionsControls311";
    GroupId["SanctionsControls312"] = "SanctionsControls312";
    GroupId["SanctionsControls313"] = "SanctionsControls313";
    GroupId["SanctionsControls32"] = "SanctionsControls32";
    GroupId["SanctionsControls33"] = "SanctionsControls33";
    GroupId["SanctionsControls341"] = "SanctionsControls341";
    GroupId["SanctionsControls35"] = "SanctionsControls35";
    GroupId["SanctionsControls36"] = "SanctionsControls36";
    GroupId["SanctionsControls37"] = "SanctionsControls37";
    GroupId["SanctionsControls38"] = "SanctionsControls38";
    GroupId["SanctionsControls39"] = "SanctionsControls39";
    GroupId["SensitiveGoods"] = "SensitiveGoods";
    GroupId["SubMerchantPortfolioInfo1"] = "SubMerchantPortfolioInfo1";
    GroupId["SubMerchantPortfolioInfo2"] = "SubMerchantPortfolioInfo2";
    GroupId["SubMerchantPortfolioInfo3"] = "SubMerchantPortfolioInfo3";
    GroupId["SubMerchantPortfolioInfo4"] = "SubMerchantPortfolioInfo4";
    GroupId["SubMerchantPortfolioInfo5"] = "SubMerchantPortfolioInfo5";
    GroupId["SubMerchantPortfolioInfo6AdultServices"] = "SubMerchantPortfolioInfo6AdultServices";
    GroupId["SubMerchantPortfolioInfo6Crypto"] = "SubMerchantPortfolioInfo6Crypto";
    GroupId["SubMerchantPortfolioInfo6FinancialServices"] = "SubMerchantPortfolioInfo6FinancialServices";
    GroupId["SubMerchantPortfolioInfo6Gambling"] = "SubMerchantPortfolioInfo6Gambling";
    GroupId["UpsellStores"] = "UpsellStores";
})(GroupId || (exports.GroupId = GroupId = {}));
